import { Component, Input, OnInit } from '@angular/core';
import { fadeAnimation } from '../../animations/animations';

@Component({
    selector: 'app-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss'],
    animations: [fadeAnimation],
    standalone: false
})
export class ListItemComponent {
  @Input() text: string;
  @Input() text2: string;

  @Input() iconSource: 'fas' | 'far' | 'fab';
  @Input() icon: string;
  @Input() iconRight = true;

  constructor() { }
 
}
